import { useState, useEffect } from 'react'
import { apiService, Setting } from '@/services/api'

interface SettingsValues {
  elementsPerPageDashboard: number
  elementsPerPageContacts: number
  elementsPerPageCompanies: number
}

interface UseSettingsReturn {
  settings: SettingsValues
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

// Valeurs par défaut
const DEFAULT_SETTINGS: SettingsValues = {
  elementsPerPageDashboard: 5,
  elementsPerPageContacts: 15,
  elementsPerPageCompanies: 15
}

export function useSettings(): UseSettingsReturn {
  const [settings, setSettings] = useState<SettingsValues>(DEFAULT_SETTINGS)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchSettings = async () => {
    try {
      setLoading(true)
      setError(null)
      
      const response = await apiService.getSettings()
      
      if (response.success && response.data) {
        const settingData = response.data as Setting
        
        const newSettings: SettingsValues = {
          elementsPerPageDashboard: settingData.elementsPerPageDashboard || DEFAULT_SETTINGS.elementsPerPageDashboard,
          elementsPerPageContacts: settingData.elementsPerPageContacts || DEFAULT_SETTINGS.elementsPerPageContacts,
          elementsPerPageCompanies: settingData.elementsPerPageCompanies || DEFAULT_SETTINGS.elementsPerPageCompanies,
        }
        
        setSettings(newSettings)
      } else {
        // Si aucun paramètre n'est défini, utiliser les valeurs par défaut
        setSettings(DEFAULT_SETTINGS)
      }
    } catch (err) {
      console.error('Erreur lors du chargement des paramètres:', err)
      setError('Impossible de charger les paramètres')
      // En cas d'erreur, utiliser les valeurs par défaut
      setSettings(DEFAULT_SETTINGS)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchSettings()
  }, [])

  return {
    settings,
    loading,
    error,
    refetch: fetchSettings
  }
} 